import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

//import user from "./modules/user";
import auth from "./modules/auth";
import enquiryFilter from "./modules/enquiry-filter";
import bookingFilter from "./modules/booking-filter";
import tours from "./modules/tours";
import departures from "./modules/departures";
import discount from "./modules/discount";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  plugins: [createPersistedState()],
  modules: {
    //user
    auth,
    enquiryFilter,
    bookingFilter,
    tours,
    departures,
    discount
  }
});
